import { createContext, useState } from "react";

const WorkspaceAppModelContext = createContext({});

export function WorkspaceAppModelContextProvider({ children }) {
    const [selectedTab, setSelectedTab] = useState(0);
    const [formsWithChanges, setFormsWithChanges] = useState({
        entityForm: false,
        attributeForm: false,
        linkedEntityForm: false,
        portalForm: false,
        menuItemForm: false
    });
    const [formSaveFunction, setFormSaveFunction] = useState(() => {})
    const [selectedEntity, setSelectedEntity] = useState({});
    const [selectedAttribute, setSelectedAttribute] = useState({});
    const [selectedPortal, setSelectedPortal] = useState({});
    
    return (
        <WorkspaceAppModelContext.Provider
            value={{
                state: {
                    formsWithChanges,
                    formSaveFunction,
                    selectedEntity,
                    selectedAttribute,
                    selectedPortal,
                    selectedTab
                },
                mutators: {
                    setFormsWithChanges,
                    setFormSaveFunction,
                    setSelectedEntity,
                    setSelectedAttribute,
                    setSelectedPortal,
                    setSelectedTab
                }
            }}>
            { children }
        </WorkspaceAppModelContext.Provider>
    )
}

export default WorkspaceAppModelContext;